import { StyledUnitCard } from "../../../styles/StyledUnitCard";
import { PropTypes } from "prop-types";
import { MoreActions } from "../../MoreActions";
import { CloseBtn } from "../../CloseBtn";
import CloseIcon from "../../../assets/img/icons/close.svg";

export default function UnitCard({ 
	id, 
	name, 
	color, 
	state, 
	openDropdowns, 
	setOpenDropdowns, 
	direction = "left", 
	moreActionsPosition = "absolute", 
	deleteFunc 
}) {
	let acronym = "";
	name.split(" ").map((e, i) => {
		if (i < 2) acronym += e.split("")[0];
	});

	switch (state) {
		case "delete":
			return (
				<StyledUnitCard id={id} color={color} type={"secondary"}>
					<div className="icon">
						<span>{acronym}</span>
					</div>
					<span>{name}</span>
					<CloseBtn onClick={() => deleteFunc(id)} icon={CloseIcon} small />
				</StyledUnitCard>
			);
		case "primary":
			return (
				<StyledUnitCard id={id} color={color} type={"primary"}>
					<div className="icon">
						<span>{acronym}</span>
					</div>
					<span>{name}</span>
				</StyledUnitCard>
			);
		case "moreActions":
			return (
				<StyledUnitCard id={id} color={color} type={"secondary"}>
					<div className="icon">
						<span>{acronym}</span>
					</div>
					<span>{name}</span>
					<MoreActions
						type={id.toString()}
						options={[
							{
								display: true,
								click: () => {},
								testId: "unit-edit",
								name: "Edit unit",
							},
							{
								display: true,
								click: () => {},
								testId: "unit-remove",
								name: "Remove unit",
							},
						]}
						isOpen={openDropdowns}
						setIsOpen={setOpenDropdowns}
						isDisabled={false}
						direction={direction}
						moreActionsPosition={moreActionsPosition}
					/>
				</StyledUnitCard>
			);
		default:
			return (
				<StyledUnitCard id={id} color={color}>
					<div className="icon">
						<span>{acronym}</span>
					</div>
					<span>{name}</span>
				</StyledUnitCard>
			);
	}
}

UnitCard.propTypes = {
	id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	name: PropTypes.string,
	color: PropTypes.string,
	state: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	openDropdowns: PropTypes.object,
	setOpenDropdowns: PropTypes.func,
	deleteFunc: PropTypes.func,
	direction: PropTypes.string,
	moreActionsPosition: PropTypes.string,
};
